import MaskCoupon from './MaskCoupon'
import ReactDOM from 'react-dom/client'
import React from 'react'

export const openMaskCoupon = (
  params: {
    pathName:string
    type:'create' | 'active' 
    onDialogClose?: Function // 取消回调
    callback?:(isPop: boolean) => void,
    cb?: any// 首页的海报创作相似，需要判断是否登录、是否会员、是否9.9、是否拦截等等，判断条件结束后cb()
  } ,
) => {
  const {pathName, onDialogClose,type,callback, cb, ...rest } = params
  const dom = document.getElementById('maskCouponWrapper')
  dom && dom.parentElement && dom.parentElement.removeChild(dom)
  const container = document.createElement('div')
  // const id = new Date().getTime() + 'exportDialog';
  const id = 'maskCouponWrapper'
  container.setAttribute('id', id)
  document.body.appendChild(container)
  const root = ReactDOM.createRoot(container)

  const cancel = () => {
    root.unmount()
    container && container.parentElement && container.parentElement.removeChild(container)
  }
  window.addEventListener('popstate', function (event) {
    cancel()
  })

  return root.render(
    <MaskCoupon
       type={type}
       cb={cb}
       callback={callback}
    //    visible={true}
       onClose={e => {
        cancel()
        onDialogClose && onDialogClose(e)
      }}
      pathName={pathName}
      {...rest}
    />,
  )
}